import { format, isToday } from 'date-fns';
import { FormPart, FormStateName, part, state } from '~/lib/FormCssApi';

const DayHeading = ({ onClick, date, isSelected, isDisabled }) => {
    return (
        <div
            {...part(FormPart.DAY_HEADING)}
            {...state(
                isSelected && FormStateName.SELECTED,
                isDisabled && FormStateName.UNAVAILABLE,
                isToday(date) && FormStateName.TODAY,
            )}
            className={`${isSelected ? 'themed-bg-light outline outline-1 themed-outline' : ''} ${isDisabled ? 'opacity-50' : !!onClick ? 'cursor-pointer' : ''} rounded-lg bg-gray-200 pb-3 pt-0 px-2 flex-1 flex flex-col items-center justify-center text-center`}
            onClick={!isDisabled ? onClick : null}
        >
            <div
                className={`'uppercase text-[10px] ${isToday(date) ? 'tag themed-bg -mt-2' : ''} font-bold themed-text'`}
            >
                {isToday(date) ? 'Today' : <>&nbsp;</>}
            </div>
            <div className="text-xs ">{format(date, 'ccc')}</div>
            <div className="font-medium text-lg">{format(date, 'd')}</div>
        </div>
    );
};

export default DayHeading;
